import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { KpiCard } from "@/components/KpiCard";
import { money } from "@/lib/api";

const Liste = ({ titre, vide, children, testId }) => (
  <div data-testid={testId}>
    <p className="mb-1 text-sm font-semibold text-slate-800">{titre}</p>
    {children.length ? <div className="max-h-64 space-y-1 overflow-y-auto">{children}</div> : <p className="text-xs text-slate-500">{vide}</p>}
  </div>
);

// Cadre « Non rapprochés » cliquable : détail des réservations et des dépôts sans correspondance
export const NonRapprochesKpi = ({ k, detail }) => {
  const [ouvert, setOuvert] = useState(false);
  const d = detail || { reservations: [], depots: [] };
  return (
    <>
      <button type="button" onClick={() => setOuvert(true)} title="Voir le détail des non rapprochés" className="group text-left rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600 rise-4" data-testid="kpi-non-rapproches-lien">
        <KpiCard label="Non rapprochés" value={`${k.reservations_non_rapprochees} rés. · ${k.depots_non_rapproches} dépôts`}
          sub={<>{money(k.montant_reservations_non_rapprochees)} en attente · {k.a_valider} à valider <span className="ml-1 text-emerald-700 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">Voir le détail →</span></>}
          tone={k.reservations_non_rapprochees + k.depots_non_rapproches > 0 ? "warn" : "good"} testId="kpi-non-rapproches" className="h-full cursor-pointer group-hover:border-emerald-400" />
      </button>
      <Dialog open={ouvert} onOpenChange={setOuvert}>
        <DialogContent className="max-w-3xl" data-testid="non-rapproches-dialog">
          <DialogHeader>
            <DialogTitle>Non rapprochés</DialogTitle>
            <DialogDescription>Réservations sans dépôt correspondant et dépôts Airbnb/Booking sans réservation, pour les filtres affichés.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <Liste titre={`Réservations (${d.reservations.length}) · ${money(k.montant_reservations_non_rapprochees)}`} vide="Aucune réservation en attente." testId="non-rapproches-reservations">
              {d.reservations.map((r) => (
                <div key={r.id} className="flex flex-wrap gap-x-3 border-t border-slate-100 py-1 text-xs" data-testid={`non-rapproche-resa-${r.id}`}>
                  <span className="font-mono">{r.code}</span><span>{r.client}</span><span className="text-slate-500">{r.plateforme} · {r.logement}</span>
                  <span className="text-slate-500">{r.debut}{r.fin ? ` → ${r.fin}` : ""}</span><span className="ml-auto tabular">{money(r.montant)}</span>
                </div>
              ))}
            </Liste>
            <Liste titre={`Dépôts (${d.depots.length})`} vide="Aucun dépôt sans réservation." testId="non-rapproches-depots">
              {d.depots.map((t) => (
                <div key={t.id} className="flex gap-3 border-t border-slate-100 py-1 text-xs" data-testid={`non-rapproche-depot-${t.id}`}>
                  <span className="font-mono text-slate-500">{t.date}</span><span className="flex-1 min-w-0 break-words">{t.description}</span><span className="tabular">{money(t.montant)}</span>
                </div>
              ))}
            </Liste>
            <Link to="/rapprochement" className="inline-block text-sm font-medium text-emerald-700 hover:underline" data-testid="non-rapproches-aller">Aller au rapprochement →</Link>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
